import { Box, GlobalStyles, SelectChangeEvent } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import Navbar from './Navbar'
import { useGetReportYearsQuery } from 'gqlTypes'
import ReportsYearContent from './ReportYears/Content'

const ReportsYearPage: React.FC = () => {
  const [selectedYear, setSelectedYear] = useState<number | undefined>()
  const {
    data: yearsData,
    loading: yearsLoading,
    error: yearsError,
  } = useGetReportYearsQuery()

  const initSelectedYear = useRef(false)

  const handleUpdateYear = (event: SelectChangeEvent) => {
    setSelectedYear(parseInt(event.target.value) || selectedYear)
  }

  useEffect(() => {
    if (!initSelectedYear.current && yearsData?.reportYears?.length) {
      initSelectedYear.current = true
      setSelectedYear(yearsData.reportYears[0])
    }
  }, [yearsData])

  return (
    <>
      <GlobalStyles styles={{ body: { backgroundColor: '#fff' } }} />
      <Navbar />
      {yearsError && (
        <Box m={4}>
          There was an error loading your reports. Please reload the page and
          try again.
        </Box>
      )}
      {!!yearsData?.reportYears?.length && selectedYear && (
        <ReportsYearContent
          selectedYear={selectedYear}
          years={yearsData?.reportYears}
          onUpdateYear={handleUpdateYear}
        />
      )}
    </>
  )
}

export default ReportsYearPage
